import React from "react";
import { DefaultButton, PrimaryButton, Stack } from "office-ui-fabric-react";
import { useParams } from "react-router-dom";
import {
  getCustomerDatacenters,
  getCustomerMinimumCommittedPower,
  updateCustomerMinimumCommittedPower,
} from "../../../services/customers/CustomerService";
import { Loading } from "../../../services/Loading";
import { IDataCenter, IMinimumCommitted } from "../../../vm";
import { ToastContext } from "../../common/ToastProvider";
import NoDataTile from "../../common/NoDataTile";
import { Formik } from "formik";
import { CustomTextField } from "../../common/Library";
import { childrenGap } from "../../common/Constants";
// import * as yup from "yup";
import { parseJwt, toFixedValue } from "../../../services/UtilService";

// const schema = yup.object().shape({
//   committedKwh: yup
//     .number()
//     .min(100000, "Value needs to be more than 100000")
//     .max(200000, "Value needs to be less than 200000"),
// });

// const remarksSchema = yup.array().of(schema);

export interface MinimumCommittedProps { }

const MinimumCommitted: React.FC<MinimumCommittedProps> = () => {
  //custom hooks
  const params: any = useParams();
  const { showToast } = React.useContext(ToastContext);

  const tokenData = parseJwt();

  //state
  const [state, setState] = React.useState({
    isLoading: false,
    minimumCommitted: [],
    datacenters: [],
    isOnEdit: false,
  } as {
    isLoading: boolean;
    minimumCommitted: IMinimumCommitted[];
    datacenters: any;
    isOnEdit: boolean;
  });

  React.useEffect(() => {
    const asyncFunc = async () => {
      await getAllDatacenter();
    };
    asyncFunc();
  }, []);

  const getAllDatacenter = async () => {
    setState({ ...state, isLoading: true });
    let result = await getCustomerDatacenters({
      customerId: params.customerId,
      isLite: false,
    });
    if (result?.success) {
      getMinimumCommittedPower(result.data);
    } else {
      setState({ ...state, isLoading: false });
      showToast(
        result.message || "Error while getting customer datacenters",
        "error"
      );
    }
  };

  const getMinimumCommittedPower = async (datacenters: any) => {
    setState({ ...state, isLoading: true });
    let result = await getCustomerMinimumCommittedPower({
      customerId: params.customerId,
    });
    if (result?.success) {
      let minimumCommitted: IMinimumCommitted[] = [];

      datacenters.forEach((datacenter: IDataCenter) => {
        let item: IMinimumCommitted = result.data.find(
          (i) => i.datacenterId === datacenter._id
        );

        const buildingDict = datacenter.buildings.reduce((acc: any, b: any) => {
          acc[b._id?.toString() as string] = b.name;
          return acc;
        }, {});
        const floorDict = datacenter.floors.reduce((acc: any, b) => {
          acc[b._id?.toString() as string] =
            buildingDict[b.buildingId.toString()] + "-" + b.name;
          return acc;
        }, {});
        item["datacenterName"] = datacenter.name;
        item.power = item.power.map((p) => {
          p.name = p.name ? p.name : floorDict[p.floorId];
          return p;
        });

        minimumCommitted.push(item);
        // minimumCommitted.push({
        //   customerId: params.customerId,
        //   datacenterId: datacenter._id,
        //   datacenterName: datacenter.name,
        //   committedKwh: item?.committedKwh,
        //   committedKw: item?.committedKw,
        // });
      });
      // console.log("m", minimumCommitted);

      setState({
        ...state,
        datacenters,
        minimumCommitted,
        isLoading: false,
      });
    } else {
      setState({ ...state, isLoading: false });
      showToast(
        result.message || "Error while getting minimum committed power",
        "error"
      );
    }
  };

  const handleLoading = () => {
    setState({
      ...state,
      isLoading: !state.isLoading,
    });
  };

  return (
    <React.Fragment>
      {state.isLoading && <Loading />}
      <div>
        {state.datacenters && state.datacenters.length > 0 ? (
          <div
            // style={{
            //   width: "40%",
            //   // margin: "auto",
            // }}
            // className="pt-16"
            className="minimum-committed-table"
          >
            <Formik
              enableReinitialize
              initialValues={state.minimumCommitted}
              // validationSchema={remarksSchema}
              onSubmit={async (
                values: IMinimumCommitted[],
                { setSubmitting }
              ) => {
                let data = [...values];
                handleLoading();
                let result = await updateCustomerMinimumCommittedPower(data);
                handleLoading();
                if (result?.success) {
                  setState({
                    ...state,
                    minimumCommitted: data,
                    isOnEdit: false,
                  });
                  showToast(
                    "Minimum Committed value updated successfully",
                    "success"
                  );
                } else {
                  setState({ ...state, isOnEdit: false });
                  showToast(
                    result.message ||
                    "Error while updating minimum committed value",
                    "error"
                  );
                }
                setSubmitting(false);
              }}
            >
              {({ handleSubmit, values }) => (
                <form onSubmit={handleSubmit}>
                  <Stack className="pt-16">
                    {![2, 4, 5].includes(tokenData.role) && (
                      <Stack.Item>
                        {state.isOnEdit === false && (
                          <PrimaryButton
                            text="Edit"
                            onClick={() =>
                              setState({ ...state, isOnEdit: true })
                            }
                          />
                        )}
                      </Stack.Item>
                    )}
                    <Stack.Item>
                      {state.isOnEdit === true && (
                        <Stack horizontal wrap tokens={childrenGap}>
                          <PrimaryButton type="submit" text="Submit" />
                          <DefaultButton
                            text="Cancel"
                            onClick={() =>
                              setState({ ...state, isOnEdit: false })
                            }
                            className="borderless-btn"
                          />
                        </Stack>
                      )}
                    </Stack.Item>
                    <br />
                    <Stack.Item>
                      <div className="office-table bg-white">
                        <table className="ms-Table bordered-table">
                          <thead className="html-table-thead">
                            <tr style={{ height: 44 }}>
                              <th>Datacenter Name</th>
                              <th>Floor</th>
                              <th>Minimum Committed(KWH)</th>
                              <th>Minimum Committed(KW)</th>
                              <th>Minimum Committed(KVA)</th>
                              <th>Contracted Rated Power</th>
                              <th>Populated Rated Power</th>
                              <th>Contracted Bundled Power</th>
                            </tr>
                          </thead>
                          <tbody>
                            {values.reduce(
                              (
                                acc: any,
                                item: IMinimumCommitted,
                                index: number
                              ) => {
                                // console.log("i", index, "item", item);
                                item.power.forEach((d, inx) => {
                                  acc.push(
                                    <tr key={index + "" + inx}>
                                      {state.isOnEdit === false ? (
                                        <>
                                          {inx === 0 && (
                                            <td
                                              rowSpan={item.power.length}
                                              align="center"
                                            >
                                              {item?.datacenterName || ""}
                                            </td>
                                          )}
                                          <td width={100}>
                                            {/* {d?.floorName || ""} */}
                                            {d?.name || ""}
                                          </td>
                                          <td align="right" width={80}>
                                            {/* {d?.committedKwh || 0} */}
                                            {toFixedValue(d?.committedKwh)}
                                          </td>
                                          <td align="right" width={80}>
                                            {/* {d?.committedKw || 0} */}
                                            {toFixedValue(d?.committedKw)}
                                          </td>
                                          <td align="right" width={80}>
                                            {/* {d?.committedKva || 0} */}
                                            {toFixedValue(d?.committedKva)}
                                          </td>
                                          <td align="right" width={80}>
                                            {toFixedValue(d?.contractedRatedPower || 0)}
                                          </td>
                                          <td align="right" width={80}>
                                            {toFixedValue(d?.populatedRatedPower || 0)}
                                          </td>
                                          <td align="right" width={80}>
                                            {toFixedValue(d?.bundledCommitted || 0)}
                                          </td>
                                        </>
                                      ) : (
                                        <>
                                          {inx === 0 && (
                                            <td rowSpan={item.power.length}>
                                              {item?.datacenterName || ""}
                                            </td>
                                          )}
                                          {/* <td>{d?.floorName || ""}</td> */}
                                          <td>{d?.name || ""}</td>
                                          <td width={120}>
                                            <CustomTextField
                                              name={`[${index}].power[${inx}].committedKwh`}
                                              type="number"
                                            />
                                          </td>
                                          <td width={120}>
                                            <CustomTextField
                                              name={`[${index}].power[${inx}].committedKw`}
                                              type="number"
                                            />
                                          </td>
                                          <td width={120}>
                                            <CustomTextField
                                              name={`[${index}].power[${inx}].committedKva`}
                                              type="number"
                                            />
                                          </td>
                                          <td width={120}>
                                            <CustomTextField
                                              name={`[${index}].power[${inx}].contractedRatedPower`}
                                              type="number"
                                            />
                                          </td>
                                          <td width={120}>
                                            <CustomTextField
                                              name={`[${index}].power[${inx}].populatedRatedPower`}
                                              type="number"
                                            />
                                          </td>
                                          <td width={120}>
                                            <CustomTextField
                                              name={`[${index}].power[${inx}].bundledCommitted`}
                                              type="number"
                                            />
                                          </td>
                                        </>
                                      )}
                                    </tr>
                                  );
                                });

                                return acc;
                              },
                              []
                            )}
                          </tbody>
                        </table>
                      </div>
                    </Stack.Item>
                  </Stack>
                </form>
              )}
            </Formik>
          </div>
        ) : (
          <div className="pt-16">
            <NoDataTile title="No Datacenter Found for this Customer"></NoDataTile>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default MinimumCommitted;
